import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '#app/shared/lib/misc.js'

const chipVariants = cva(
	`
   inline-flex w-fit items-center justify-center rounded-[2px]
   text-subtitle2-archivo uppercase leading-[0] ring-offset-cards transition-all
   duration-200

   disabled:pointer-events-none disabled:opacity-50

   focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
   focus-visible:ring-ring
 `,
	{
		variants: {
			variant: {
				primary: `bg-primary-600 text-white`, // primary
				secondary: `bg-secondary-600 text-white`,
				outline: `border border-gray-200 bg-transparent`,
			},
			size: {
				'24px': 'h-6 min-h-6 px-2',
				'32px': 'h-8 min-h-8 px-2',
			},
		},
		defaultVariants: {
			variant: 'outline',
			size: '32px',
		},
	},
)

export interface ButtonProps
	extends React.ButtonHTMLAttributes<HTMLDivElement>,
		VariantProps<typeof chipVariants> {}

const Chip = React.forwardRef<HTMLDivElement, ButtonProps>(
	({ className, children, variant, size, ...props }, ref) => {
		return (
			<div
				className={cn(chipVariants({ variant, size, className }))}
				ref={ref}
				{...props}
			>
				{children}
			</div>
		)
	},
)
Chip.displayName = 'Chip'

export { Chip, chipVariants }
